import React, { useEffect, useState } from "react";
import { Pagination, Stack } from "@mui/material";
import moment from "moment";
import api from "../../api";
import { Loader } from "./loader";

function UserPaidByAdmin() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [loader, setLoader] = useState(false);

  const getLogs = async () => {
    try {
      setLoader(true);
      const payload = {
        page,
        search: appliedSearch,
      };
      const res = await api.getUserPaidByAdmin(payload);
      setData(res?.logs || []);
      setCount(res?.count || 0);
      setLimit(res?.limit || 10);
    } catch (error) {
      console.log(error?.message);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getLogs();
  }, [page, appliedSearch]);

  const handleSearch = () => {
    setPage(1);
    setAppliedSearch(search.trim());
  };

  const handleReset = () => {
    setSearch("");
    setAppliedSearch("");
    setPage(1);
  };

  return (
    <div className="container-fluid payHistoryPage">
      <div className="row">
        <div className="col">
          <div className="users-management-wrapper">
            <div className="users-header-section">
              <div className="users-header-content">
                <div className="users-title-section">
                  <h1 className="users-main-title">UserPaidByAdmin</h1>
                  <p className="users-subtitle">
                    Manually subscribed users by Super Admin
                  </p>
                </div>
                <div className="users-search-section">
                  <div className="users-search-container">
                    <input
                      type="text"
                      className="users-search-input"
                      placeholder="Search by name, email, reason..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                    />
                    <button className="users-search-btn" onClick={handleSearch}>
                      Search
                    </button>
                  </div>
                  <button className="users-reset-btn" onClick={handleReset}>
                    Reset
                  </button>
                </div>
              </div>
            </div>

            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10 bg-white border-transparent py-3">
                <div className="table-responsive">
                  <table className="table table-hover drivers-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Reason</th>
                        <th>Paid On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.length > 0 ? (
                        data.map((item) => (
                          <tr key={item?._id}>
                            <td>{item?.userName || "-"}</td>
                            <td>{item?.userEmail || "-"}</td>
                            <td>{item?.reason || "-"}</td>
                            <td>
                              {item?.createdAt
                                ? moment(item.createdAt).format(
                                    "MMMM Do YYYY, h:mm:ss a",
                                  )
                                : "-"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center py-4">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-center mt-4">
                  <Stack spacing={2}>
                    <Pagination
                      count={Math.ceil(count / limit) || 1}
                      page={page}
                      onChange={(event, value) => setPage(value)}
                      color="primary"
                    />
                  </Stack>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader && <Loader />}
    </div>
  );
}

export default UserPaidByAdmin;
